import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const createNewOrder = createAsyncThunk(
    'order/createNewOrder',
    async (course_id, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(course_id);

            const response = await axios.post(`${PUBLIC_BASE_URL}/orders/create-order`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const createNewOrderForWallet = createAsyncThunk(
    'order/createNewOrderForWallet',
    async (data, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true
            };
            const body = JSON.stringify(data);

            const response = await axios.post(`${PUBLIC_BASE_URL}/orders/create-order-for-wallet-payment`, body, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const createCoursePurchaseRequest = createAsyncThunk(
    'order/createCoursePurchaseRequest',
    async (formData, { rejectWithValue }) => {
        try {
            const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      };

            const response = await axios.post(`${PUBLIC_BASE_URL}/course-purchase-requests/create-course-purchase-request`, formData, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);